import { Component, OnInit, ViewChild } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatSort, Sort } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { BeneficiaryGroup } from '@shared/beneficiary/beneficiary-group';
import { BeneficiaryGroupApi } from '@shared/beneficiary/beneficiary-group-api.service';
import { BeneficiaryGroupDashboardRow } from '@shared/beneficiary/beneficiary-group-dashboard-row';
import { BeneficiaryGroupHelper } from '@shared/beneficiary/beneficiary-group-helper.service';
import { BeneficiaryGroupStatus } from '@shared/beneficiary/beneficiary-group-status.enum';

@Component({
  selector: 'app-group-overview-widget',
  templateUrl: './group-overview-widget.component.html',
  styleUrls: ['./group-overview-widget.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatSort,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    MatHeaderCellDef,
    MatProgressBar,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatHeaderRowDef,
    RouterLink,
  ],
})
export class GroupOverviewWidgetComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatTable) rowTable!: MatTable<BeneficiaryGroupDashboardRow>;

  displayedColumns = ['code', 'coach', 'progress', 'numberOfRounds', 'nextTask'];
  inProgressStatus = BeneficiaryGroupStatus.IN_PROGRAM;

  rows!: BeneficiaryGroupDashboardRow[];

  constructor(private readonly beneficiaryGroupApi: BeneficiaryGroupApi) {}

  ngOnInit(): void {
    this.beneficiaryGroupApi
      .summary()
      .subscribe(
        result => (this.rows = result.sort(this.getCompareFn({ active: 'progress', direction: 'asc' } as Sort))),
      );
  }

  getWeeksRunning(row: BeneficiaryGroupDashboardRow): number {
    const beneficiaryGroup = new BeneficiaryGroup();
    beneficiaryGroup.status = row.status;
    beneficiaryGroup.startDate = row.startDate;

    return BeneficiaryGroupHelper.getWeeksRunning(beneficiaryGroup);
  }

  sortData($event: Sort): void {
    if ($event.direction === '') {
      this.rows.sort(this.getCompareFn({ active: 'code' } as Sort));
    } else {
      this.rows.sort(this.getCompareFn($event));
      if ($event.direction === 'desc') {
        this.rows.reverse();
      }
    }
    this.rowTable.renderRows();
  }

  private getCompareFn(sortCommand: Sort) {
    return (value1: BeneficiaryGroupDashboardRow, value2: BeneficiaryGroupDashboardRow): number => {
      let compareValue1 = '';
      let compareValue2 = '';

      if (sortCommand.active === 'code') {
        compareValue1 = value1?.code ? value1.code : '';
        compareValue2 = value2?.code ? value2.code : '';
      } else if (sortCommand.active === 'coach') {
        compareValue1 = value1?.coach ? value1.coach : '';
        compareValue2 = value2?.coach ? value2.coach : '';
      } else if (sortCommand.active === 'progress') {
        if (value1.status.code !== value2.status.code) {
          if (value1.status.displayOrder && value2.status.displayOrder) {
            return value1.status.displayOrder - value2.status.displayOrder;
          } else if (value1.status.description && value2.status.description) {
            return value1.status.description.localeCompare(value2.status.description);
          } else {
            return value1.status.code.localeCompare(value2.status.code);
          }
        } else {
          if (value1.status.code === BeneficiaryGroupStatus.IN_PROGRAM) {
            return this.getWeeksRunning(value1) - this.getWeeksRunning(value2);
          } else {
            compareValue1 = value1?.code ? value1.code : '';
            compareValue2 = value2?.code ? value2.code : '';
          }
        }
      } else if (sortCommand.active === 'numberOfRounds') {
        compareValue1 = (value1?.numberOfRounds ? value1.numberOfRounds : 0).toString();
        compareValue2 = (value2?.numberOfRounds ? value2.numberOfRounds : 0).toString();
      } else if (sortCommand.active === 'nextTask') {
        compareValue1 = value1?.nextTask?.title ? value1.nextTask.title : '';
        compareValue2 = value2?.nextTask?.title ? value2.nextTask.title : '';
      }

      return compareValue1
        ? compareValue1.localeCompare(compareValue2, undefined, {
            numeric: true,
            sensitivity: 'base',
          })
        : -1;
    };
  }
}
